import { download } from '@/api/common'

const getImg = val => {
  if (val) {
    return `${download}${val}`
  }
}

export default getImg
